import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";






const JavaScriptLesson12 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <div className="alert alert-secondary" role="alert">
    <h3><strong>Variable Naming Conventions</strong></h3>
    <p>Follow the following rules to name your variables:</p>
    <ol class="list-group list-group-numbered">
      <li class="list-group-item">Do not use any of the JavaScript reserved words, e.g, <var>break, await</var>, etc.</li>
      <li class="list-group-item">Variables should not start with a numeral (0-9), they must begin with a letter or an underscore character.</li>
      <li class="list-group-item">Use camelCase for variable names where necessary. e.g. <var>doSomething(), startSomething(), sayHello()</var></li>
      <li class="list-group-item">JavaScript variable names are case-sensitve. "greeting" is different from "Greeting"</li>
      <li class="list-group-item">Variable names should be self-descriptive and describe the stored value.</li>
    </ol>
    </div>

    <div className="alert alert-secondary" role="alert">
    <h3><strong>Summary</strong></h3>
    <ul class="list-group list-group-numbered">
      <li class="list-group-item">Variables can be declared with either <strong><i>var, let,</i></strong> or <strong><i>const</i></strong></li>
      <li class="list-group-item">Unless you are declaring a variable whose value will not change, like PI (&pi;), use let for your variable declaration</li>
      <li class="list-group-item">Variable hoisting is a JavaScript mechanism where variables declarations are moved to the top of their scope before code execution.</li>
      <li class="list-group-item">Variable names should be camelCase where necessary</li>
      <li class="list-group-item">A variable can either have a global or local scope.</li>
      <li class="list-group-item">JavaScript is <strong>untyped</strong> programming language. You don't have to worry about data type during declaration.</li>
    </ul>
    </div>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson12
